import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

var bnrimg = require('./../../images/banner/2.jpg');

class ProjectGrid extends React.Component {
    state = {
        projects: [],
        services: [],
        loading: true
    };

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const [projectsRes, servicesRes] = await Promise.all([
                axiosClient.get(apiConfig.PROJECTS.GET_ALL),
                axiosClient.get(apiConfig.SERVICES.GET_ALL)
            ]);

            this.setState({
                projects: projectsRes.data.data,
                services: servicesRes.data.data,
                loading: false
            }, () => {
                if (window.initMasonryAndPopup) {
                    setTimeout(() => {
                        window.initMasonryAndPopup();
                    }, 100);
                }
            });
        } catch (error) {
            console.error("Error fetching data", error);
            this.setState({ loading: false });
        }
    }

    render() {
        const { projects, services, loading } = this.state;

        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title="Always dedicated and devoted" pagename="Project Grid" bgimage={bnrimg} />

                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            {loading ? (
                                <div className="text-center p-a50">Loading projects...</div>
                            ) : (
                                <>
                                    <div className="filter-wrap p-b30 text-center">
                                        <ul className="filter-navigation inline-navigation masonry-filter link-style text-uppercase">
                                            <li className="active"><NavLink to={"#"} data-filter="*" data-hover="All">All</NavLink></li>
                                            {services.map((item, index) => (
                                                <li key={index}><NavLink to={"#"} data-filter={`.cat-${item.slug}`} data-hover={item.name}>{item.name}</NavLink></li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                                        {projects.map((item, index) => {
                                            const filterClass = item.service ? `cat-${item.service.slug}` : '';
                                            return (
                                                <div key={index} className={`${filterClass} masonry-item col-md-4 col-sm-6 m-b30`}>
                                                    <div className="image-effect-two hover-shadow">
                                                        <img src={item.featured_image} alt={item.title} />
                                                        <div className="figcaption">
                                                            <h4 className="mt-tilte">{item.title}</h4>
                                                            <p>{(item.description || '').substring(0, 80)}...</p>
                                                            <NavLink
                                                                to="/project-detail"
                                                                state={{ projectSlug: item.slug }}
                                                                className="read-more site-button btn-effect"
                                                            >
                                                                Read More
                                                            </NavLink>
                                                            <a className="mfp-link" href={item.featured_image}>
                                                                <i className="fa fa-arrows-alt" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div className="m-t50 text-center">
                                        <NavLink to={"#"} className="site-button btn-effect">Load More</NavLink>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <Footer />
            </>
        );
    }
};

export default ProjectGrid;
